const separateColor = () => {
  const color_swatches = Array.from(
    document.querySelectorAll(".variant-picker__option-values .color-swatch-wrapper")
  );
  const saleSegment = document.querySelector("#saleSegment");
  const seasonalSegment = document.querySelector("#seasonalSegment");
  const normalSegment = document.querySelector("#normalSegment");
  const hiddenSegment = document.querySelector("#hiddenSegment");

  if (color_swatches) {
    if (saleSegment && seasonalSegment && normalSegment && hiddenSegment) {
      color_swatches.forEach((element) => {
        const colorSwatch = element.querySelector(".color-swatch");

        if (colorSwatch && colorSwatch.dataset.isHidden == "true") {
          hiddenSegment.appendChild(element);
        } else if (colorSwatch && colorSwatch.dataset.isSeasonal == "true") {
          seasonalSegment.appendChild(element);
          seasonalSegment.parentElement.classList.add('colorSwatch');
        } else if (colorSwatch && colorSwatch.dataset.isSale == "true") {
          saleSegment.appendChild(element);
          saleSegment.parentElement.classList.add('colorSwatch');
        } else {
          normalSegment.appendChild(element);
          normalSegment.parentElement.classList.add('colorSwatch');
        }
      });
    }
  }

  if (seasonalSegment && !seasonalSegment.hasChildNodes()) {
    seasonalSegment.parentElement.style.display = "none";
  }
  if (saleSegment && !saleSegment.hasChildNodes()) {
    saleSegment.parentElement.style.display = "none";
  }
  if (normalSegment && !normalSegment.hasChildNodes()) {
    normalSegment.parentElement.style.display = "none";
  }
  if (hiddenSegment) {
    hiddenSegment.parentElement.style.display = "none";
  }
};

document.addEventListener("DOMContentLoaded", function() {
  separateColor();
});

document.addEventListener("variant:change", function() {
  setTimeout(() => {
    separateColor();
  }, 10);
});